﻿export function setupLogoutButtons() {
    document.querySelectorAll('button[data-logout="true"]').forEach(logoutButton => {
        logoutButton.addEventListener('click', onLogoutButtonClick);
    });
}

function onLogoutButtonClick(event) {
    const logoutButton = event.currentTarget;
    handleLogout(logoutButton.dataset.href, logoutButton.dataset.antiForgeryToken);
}

function handleLogout(href, csrfToken) {
    const formData = new FormData();
    formData.append('__RequestVerificationToken', csrfToken);

    fetch(href, {
        method: 'POST',
        body: formData
    }).then(response => {
        if (response.ok) {
            response.json().then(json => window.location = json.redirectUrl);
        } else {
            console.log("Something went wrong executing background logout");
            window.location.reload();
        }
    }).catch(error => {
        console.log("Something went wrong executing background logout", error);
        window.location.reload();
    });
}